/* tslint:disable */
/* eslint-disable */
/**
 * AIS Coverage API
 * API for managing AIS source identifiers and calculating coverage.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CoverageImagePost200Response
 */
export interface CoverageImagePost200Response {
    /**
     * Base64-encoded PNG image.
     * @type {string}
     * @memberof CoverageImagePost200Response
     */
    image: string;
    /**
     * Coordinates for the image extent, formatted as a string.
     * @type {string}
     * @memberof CoverageImagePost200Response
     */
    viewBoxCoordinates: string;
}

/**
 * Check if a given object implements the CoverageImagePost200Response interface.
 */
export function instanceOfCoverageImagePost200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "image" in value;
    isInstance = isInstance && "viewBoxCoordinates" in value;

    return isInstance;
}

export function CoverageImagePost200ResponseFromJSON(json: any): CoverageImagePost200Response {
    return CoverageImagePost200ResponseFromJSONTyped(json, false);
}

export function CoverageImagePost200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CoverageImagePost200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'image': json['image'],
        'viewBoxCoordinates': json['view_box_coordinates'],
    };
}

export function CoverageImagePost200ResponseToJSON(value?: CoverageImagePost200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'image': value.image,
        'view_box_coordinates': value.viewBoxCoordinates,
    };
}

